import {getKeyboardOrMouse} from 'app/utils/initialize/initKeyboardOrMouse';

export function scrollToTop() {
    window.scrollTo({top: 0, behavior: 'smooth'});

    if (getKeyboardOrMouse() === 'KEYBOARD') {
        document.querySelector<HTMLElement>('a.skiplinks__item')?.focus({preventScroll: true});
    } else {
        const focusableElements = Array.from(document.querySelectorAll<HTMLElement>('a:not(.skiplinks__item), button, input, select, textarea'));
        for (const element of focusableElements) {
            element.focus({preventScroll: true});
            if (document.activeElement === element) {
                break;
            }
        }
    }
}
